/**
 * Uploads a file to Cloudflare R2 using a presigned URL.
 * @param {File} file - The file to upload.
 * @param {string} presignedUrl - A presigned URL from your backend/worker.
 * @returns {Promise<void>}
 */
export async function uploadToR2(file, presignedUrl) {
  try {
    const response = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    console.log("✅ Upload successful!");
  } catch (error) {
    console.error("❌ Upload error:", error);
    throw error;
  }
}
